import { routeAlias, routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const caseRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.cases,
    name: routeNames.cases,
    component: () => import('@/pages/cases/CasesView.vue'),
    meta: {
      icon: 'material-symbols-outlined',
      iconText: 'topic',
      permission: 'cases.read.all',
      labelKey: 'cases',
    },
  },
  {
    path: routePaths.caseCreation,
    name: routeNames.caseCreation,
    component: () => import('@/pages/cases/AddEditCaseView.vue'),
    meta: {
      labelKey: 'new_f',
      permission: 'cases.write.all',
      rootRouteName: routeNames.cases,
    },
  },
  {
    path: routePaths.caseEdit,
    name: routeNames.caseEdit,
    component: () => import('@/pages/cases/AddEditCaseView.vue'),
    meta: {
      labelKey: 'edit',
      permission: 'cases.write.all',
      rootRouteName: routeNames.cases,
    },
  },
  {
    path: routePaths.caseDetails,
    component: () => import('@/pages/cases/CaseDetailsView.vue'),
    meta: {
      // The label is practices to handle the /cases/:id/practices alias
      labelKey: 'practices',
      permission: 'cases.read.all',
      rootRouteName: routeNames.cases,
    },
    children: [
      {
        path: '',
        name: routeNames.caseDetails,
        alias: routeAlias.caseDetails,
        component: () => import('@/pages/cases/tabs/CasePracticesTab.vue'),
        meta: {
          labelKey: 'practices',
          permission: 'cases.read.all',
        },
      },
      {
        path: routePaths.caseDetailsEvents,
        name: routeNames.caseDetailsEvents,
        component: () => import('@/pages/cases/tabs/CaseEventsTab.vue'),
        meta: {
          labelKey: 'caseDetailsEvents',
          permission: 'cases.read.all',
        },
      },
      {
        path: routePaths.caseDetailsRecords,
        name: routeNames.caseDetailsRecords,
        component: () => import('@/pages/cases/tabs/CaseRecordsTab.vue'),
        meta: {
          labelKey: 'caseDetailsRecords',
          permission: 'cases.read.all',
          featureFlag: 'records',
        },
      },
      {
        path: routePaths.caseDetailsSubjects,
        name: routeNames.caseDetailsSubjects,
        component: () => import('@/pages/cases/tabs/CaseSubjectsTab.vue'),
        meta: {
          labelKey: 'caseDetailsSubjects',
          permission: 'subjects.read.all',
        },
      },
      {
        path: routePaths.caseDetailsSubjectDetails,
        name: routeNames.caseDetailsSubjectDetails,
        component: () => import('@/pages/cases/tabs/CaseSubjectDetailsTab.vue'),
        meta: {
          permission: 'subjects.read.all',
        },
      },
      {
        path: routePaths.caseDetailsSubjectRecords,
        name: routeNames.caseDetailsSubjectRecords,
        redirect: ({ params }) => ({ name: routeNames.caseDetailsSubjectDetails, params }),
        meta: {
          labelKey: 'caseDetailsSubjectRecords',
          permission: 'subjects.read.all',
          featureFlag: 'records',
        },
      },
    ],
  },
  {
    path: routePaths.caseSubjectCreation,
    name: routeNames.caseSubjectCreation,
    component: () => import('@/pages/subjects/add/AddSubjectView.vue'),
    meta: {
      labelKey: 'new_m',
      permission: 'cases.write.all',
      rootRouteName: routeNames.cases,
    },
  },
  {
    path: routePaths.caseDetailsSubjectRecordCreation,
    name: routeNames.caseDetailsSubjectRecordCreation,
    component: () => import('@/pages/subjects/record-creation/AddSubjectRecordView.vue'),
    meta: {
      labelKey: 'new_f',
      permission: 'subjects.write.all',
      rootRouteName: routeNames.cases,
      featureFlag: 'records',
    },
  },
  {
    path: routePaths.caseDetailsRecordCreation,
    name: routeNames.caseDetailsRecordCreation,
    component: () => import('@/pages/cases/record-creation/AddCaseRecordView.vue'),
    meta: {
      labelKey: 'new_f',
      permission: 'cases.write.all',
      rootRouteName: routeNames.cases,
      featureFlag: 'records',
    },
  },
]
